export function CategoryTabs({ categories, active, onChange }) {
  return (
    <div
      data-testid="category-tabs"
      className="flex overflow-x-auto scrollbar-hide gap-2 px-4 py-3"
    >
      {categories.map((c) => {
        const isActive = c === active;
        const isLive = c === "Breaking News";
        return (
          <button
            key={c}
            data-testid={`cat-tab-${c.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => onChange(c)}
            className={`relative inline-flex items-center gap-1.5 rounded-full px-5 py-1.5 text-sm font-medium whitespace-nowrap transition-all duration-200 ${
              isActive
                ? "bg-brand text-white shadow-[0_0_20px_rgba(230,59,46,0.45)]"
                : "bg-white/5 text-white/70 hover:bg-white/10 border border-white/5"
            }`}
          >
            {isLive && (
              <span className="relative flex h-2 w-2" aria-hidden="true">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-70" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.9)]" />
              </span>
            )}
            {c}
          </button>
        );
      })}
    </div>
  );
}
